'use client'

import React, { useState, useEffect } from 'react'

const ShareThis = ({ lang, url, title, description, image }) => {
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    const initializeButtons = () => {
      if (!initialized && typeof window !== 'undefined' && window.__sharethis__) {
        // Initialize with our custom configuration
        window.__sharethis__.init({
          inline_share_buttons: {
            alignment: 'left',
            color: 'social',
            enabled: true,
            font_size: 4,
            labels: 'null',
            language: lang?.slice(0, 2) || 'en',
            min_count: 0,
            padding: 8,
            radius: 0,
            networks: ['facebook', 'messenger', 'sharethis', 'whatsapp'],
            size: 32,
            spacing: 4,
            url: url,
            title: title,
            description: description,
            image: image,
          },
        })
        setInitialized(() => true)
      }
    }

    const checkAndInitialize = () => {
      if (!initialized) {
        initializeButtons()
      } else {
        setTimeout(checkAndInitialize, 100)
      }
    }

    checkAndInitialize()
  }, [url, title, description, image, lang, initialized])

  return (
    <div className="w-full">
      <div className="inline-block sharethis-inline-share-buttons" style={{ minWidth: 0 }} />
    </div>
  )
}

export default ShareThis
